var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "global-layout",
    { on: { dynamicRouterShow: _vm.dynamicRouterShow } },
    [
      _vm.multipage
        ? _c(
            "a-tabs",
            {
              staticClass: "tab-layout-tabs",
              staticStyle: { height: "52px" },
              attrs: {
                "active-key": _vm.activePage,
                "hide-add": true,
                type: "editable-card"
              },
              on: {
                change: _vm.changePage,
                tabClick: _vm.tabCallBack,
                edit: _vm.editPage
              },
              nativeOn: {
                contextmenu: function($event) {
                  return (function(e) {
                    return _vm.onContextmenu(e)
                  })($event)
                }
              }
            },
            _vm._l(_vm.pageList, function(page) {
              return _c(
                "a-tab-pane",
                { key: page.fullPath, attrs: { id: page.fullPath } },
                [
                  _c(
                    "span",
                    {
                      attrs: { slot: "tab", pagekey: page.fullPath },
                      slot: "tab"
                    },
                    [_vm._v(_vm._s(page.meta.title))]
                  )
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { margin: "12px 12px 0" } },
        [
          _vm.multipage
            ? _c(
                "keep-alive",
                [_vm.reloadFlag ? _c("router-view") : _vm._e()],
                1
              )
            : [_vm.reloadFlag ? _c("router-view") : _vm._e()]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }